export interface ReviewCountFacets {
  byReturnFilterFacet: { needs_review: number };
}

export type SettledReviewCount =
  | { status: "ok"; count: number }
  | { status: "failed"; error: unknown };

/**
 * One failed facet request clears only that badge. An aborted batch leaves
 * every badge as it was, because a newer fetch is already in flight.
 */
export function settledReviewCounts(
  outcomes: readonly PromiseSettledResult<ReviewCountFacets>[],
  aborted: boolean,
): SettledReviewCount[] | undefined {
  if (aborted) {
    return undefined;
  }
  return outcomes.map((outcome) =>
    outcome.status === "fulfilled"
      ? { status: "ok", count: outcome.value.byReturnFilterFacet.needs_review }
      : { status: "failed", error: outcome.reason },
  );
}
